import React, { useState, useEffect, useContext } from 'react';
import { MenuContext } from 'src/context/MenuContext';
import { useSelector, useDispatch } from "react-redux";
import Header from 'src/components/common/Header';
import CommentTable from 'src/components/comment/CommentTable';
import { getCommentList } from "src/store/comment";
import Menu from 'src/components/common/Menu';
import ScrollTop from 'src/components/common/ScrollTop';
import CommentPopup from 'src/components/common/CommentPopup';
import CustomLoader from 'src/components/common/CustomLoader';
import { ValidationMessages } from 'src/components/common/ValidationMessage';

const CommentList = () => {
  const dispatch = useDispatch();
  const comments = useSelector((state) => state.comment.data);

  const [userId, setUserId] = useState(0);
  const [isPopupOpen, setPopupOpen] = useState(false);
  const [dailyWorkId, setDailyWorkId] = useState(0);
  const [dailyMemo, setDailyMemo] = useState('');
  const [validationMessages, setValidationMessages] = useState([]);
  const [loading, setLoading] = useState(true);
  const userData = localStorage.getItem('user');
  const loginUserId = JSON.parse(userData).id;
  const params = {
    t_user_id: loginUserId
  };

  useEffect(() => {
    setLoading(true);
    dispatch(getCommentList(params)).then((response) => {
      if (response.payload?.errors) {
        alert(response.payload.errors)
      }
      if (response.payload?.status) {
        setLoading(false);
      }
      if (response.payload?.status === 500) {
        setValidationMessages(response.payload.message);
      }
    })
      .catch((error) => {
        alert(error)
      });
  }, []);

  const filteredComments = comments?.comment_list?.filter((comment) => {
    return userId === 0 || comment.dairy_user_id === userId;
  });

  const handleUserFilter = (e) => {
    e.preventDefault();
    setUserId(parseInt(e.target.value, 10));
  };

  const togglePopup = (id = 0, dailyMemo) => {
    setDailyWorkId(id);
    setDailyMemo(dailyMemo);
    setPopupOpen((prev) => !prev);
  };

  const { visibleMenu } = useContext(MenuContext);

  return (
    <>
      {visibleMenu && <Menu />}
      <div className={visibleMenu ? 'menu-open' : 'menu-closed'}>
        <Header sx={{ mb: 500 }} />
        {loading ? <CustomLoader /> :
          <div id="comment-list">\
            {validationMessages && validationMessages.length > 0 && (
                <div style={{ background: "#ffe4e2" }}>
                    <ValidationMessages
                        messages={validationMessages}
                        onClose={() => setValidationMessages([])}
                    />
                </div>
            )}
            <section className="container-fluid contents-top">
              <div style={{ textAlign: 'center' }}>
                Show only Memo created by &nbsp;
                <select name="project_id" style={{ maxWidth: '100%' }} onChange={handleUserFilter}>
                  <option value="0">--------</option>
                  {comments?.comment_list?.length > 0 &&
                    comments?.comment_list?.map((val) => (
                      <option key={val.dairy_user_id} value={val.dairy_user_id}>
                        {val.dairy_user_name}
                      </option>
                    ))
                  }
                </select>
              </div>
            </section>
            <section className="container">
              <div>
                <CommentTable
                  filteredComments={filteredComments}
                  togglePopup={togglePopup}
                />
              </div>
            </section>
          </div>}
      </div>

      {isPopupOpen && (
        <>
          <div className="overlay show"></div>
          <CommentPopup
            isOpen={isPopupOpen}
            togglePopup={togglePopup}
            dailyWorkId={dailyWorkId}
            loginUserID={loginUserId}
            dailyMemo={dailyMemo}
          />
        </>
      )}

      <ScrollTop />
    </>
  );
};

export default CommentList;
